import $ from 'jquery';
import 'magnific-popup';
import '../Language/magnific-popup'

// const $register = $('#register-mini-teaser');
// const $content = $register.find('.register-mini-teaser__content');
// const $bg = $register.find('.register-mini-teaser__bg');
//
// $(document).on('click', ev => {
//     const $target = $(ev.target);
//     if (
//         $target.closest('.register-mini-teaser').length > 0
//         || $target.closest('.no-access').length > 0
//     ) {
//         return;
//     }
//     $register.addClass('d-none');
//     $register.removeAttr('style');
//     $content.removeAttr('style');
//     $bg.removeAttr('style');
//     $('.nav__page.hover').removeClass('hover');
// });
//
// $(document).on('click', '.no-access', ev => {
//     ev.preventDefault();
//
//     const $link = $(ev.currentTarget);
//     $link.closest('.nav__page--level1').addClass('hover');
//     $content.css({
//         left: `${ev.pageX + 30}px`,
//         top: `${ev.pageY - 30}px`,
//     });
//
//     $register.removeClass('d-none');
//     window.setTimeout(() => {
//         $content.css({opacity: 1});
//         $bg.css({opacity: 1});
//     }, 10);
//
// });

$('[autocomplete="new-email"]').on('paste', ev => {
    ev.preventDefault();
});
